import React from "react";
import { Label, Input } from "reactstrap";
import Tippy from "@tippyjs/react";
import { FaCircle } from "react-icons/fa";
import { IoIosInformationCircle } from "react-icons/io";
import { ReactComponent as PinkAExp } from "../../../../../../../src/assets/utils/images/svgs/aaicon.svg"
import { ReactComponent as PinkVExp } from "../../../../../../../src/assets/utils/images/svgs/vvicon.svg"

const AVAILABILITY_OPTIONS = {
	"+": { icon: <FaCircle size={20} color="#3AC47D" />, tooltip: "Beschikbaar" },
	"!": { icon: <FaCircle size={20} color="#FF8B02" />, tooltip: "Beschikbaarheid onbekend" },
	"-": { icon: <FaCircle size={20} color="#FB2E5F" />, tooltip: "Niet beschikbaar" },
	i: { icon: <IoIosInformationCircle size={25} color="#FB2E5F" />, tooltip: "Niet beschikbaar maar al ingepland" },
	I: { icon: <IoIosInformationCircle size={25} color="#3AC47D" />, tooltip: "Beschikbaar maar al ingepland" },
	x: { icon: <IoIosInformationCircle size={25} color="#FF8B02" />, tooltip: "Beschikbaarheid onbekend, maar al ingepland" },
	V:{icon: PinkVExp, tooltip: "Voorlopig ingepland in ander verzoek"},
	A:{icon: PinkAExp, tooltip: "Aangevraagd in ander verzoek"}
};

export default function AvailabilityOption({ value, availabilityFilter, setAvailabilityFilter }) {
	const { icon, tooltip } = AVAILABILITY_OPTIONS[value] || {};

	const checked = availabilityFilter.includes(value);

	const handleChange = () => {
		setAvailabilityFilter((prev) =>
			checked ? prev.filter((v) => v !== value) : [...prev, value]
		);
	};

	return (
		<div className="d-flex flex-column align-items-center gap-2">
			<Label for={value} className="m-0">
				<Tippy content={tooltip} placement="right" arrow>
					<span>{icon}</span>
				</Tippy>
			</Label>
			<Input
				type="checkbox"
				id={value}
				className="planscreen__checkbox m-0"
				checked={checked}
				onChange={handleChange}
			/>
		</div>
	);
}
